/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { useState } from 'react';

/* Import configuration */
import {
    DEFAULT_TIME_SERIES_GROUP,
    EXAMPLE_LAST_VALUE_REQUEST,
} from '@/config/eeCheckConfig';

/* Import hooks */
import { useDemoSensorDeviceSelection } from '@/hooks/useDemoSensorDeviceSelection';

/* Import libraries */
import { toApiDateTimeValue, toDateTimeLocalValue } from '@/lib/formatting/dateTime';

/* Import types */
import type { CurrentValueTimestampMode } from '@/types/ui';

export function useCurrentValueDemo(sensorCatalogVersion: number) {
    const selection = useDemoSensorDeviceSelection(DEFAULT_TIME_SERIES_GROUP, sensorCatalogVersion);
    const [currentValueTargets, setCurrentValueTargets] = useState<string[]>([]);
    const [currentValueTimestampMode, setCurrentValueTimestampMode] = useState<CurrentValueTimestampMode>(EXAMPLE_LAST_VALUE_REQUEST.timestamp === 'NOW' ? 'now' : 'custom');
    const [currentValueTimestamp, setCurrentValueTimestamp] = useState(toDateTimeLocalValue(EXAMPLE_LAST_VALUE_REQUEST.timestamp ?? 'NOW'));
    const currentValueRequest = {
        ...(currentValueTimestampMode === 'none'
            ? {}
            : {
                timestamp: currentValueTimestampMode === 'now'
                    ? 'NOW'
                    : currentValueTimestamp
                        ? toApiDateTimeValue(currentValueTimestamp)
                        : 'NOW',
            }),
        urn: currentValueTargets.join(','),
    };

    return {
        ...selection,
        currentValueRequest,
        currentValueTarget: selection.selectedSensorTarget,
        currentValueTargets,
        currentValueTimestamp,
        currentValueTimestampMode,
        setCurrentValueTargets,
        setCurrentValueTimestamp,
        setCurrentValueTimestampMode,
    };
}
